<template>
  <div>
    <div
      :style="{ '--brand-colour': colour }"
      :class="{ 'before-bg-colour': !!colour }"
      class="relative mr-brandContainerOffset mb-brandContainerOffset
      before:absolute before:w-full before:h-full before:top-brandContainerOffset before:left-brandContainerOffset before:rounded-brandContainerBefore
      before:border-3 before:border-solid before:border-black before:box-border
      after:bg-white after:absolute after:w-full after:h-full after:top-0 after:left-0 after:rounded-brandContainerAfter
      children:z-10 children:relative"
    >
      <div class="l-BrandContainer rounded-brandContainer border-solid border-midGrey border-1 bg-whiteOverride">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { BRAND_COLOURS } from '@/utils/colours';

export default {
  name: 'BrandContainer',
  props: {
    brandColour: {
      type: String,
      required: true,
      validator(val) {
        return Object.keys(BRAND_COLOURS).includes(val);
      },
    },
  },
  setup(props) {
    // eslint-disable-next-line arrow-body-style
    const colour = computed(() => {
      return BRAND_COLOURS[props.brandColour];
    });

    return {
      colour,
    };
  },
};
</script>

<style scoped>
.before-bg-colour::before {
  background: var(--brand-colour);
}
</style>
